export default __webpack_public_path__ + "static/media/household.97770f9f.svg";